import { FACEBOOK_BOT_ACTION_TYPES, } from './facebookBotActionTypes';


function goToMessengerBot({ currentTarget, }){
  return (dispatch, getState) => dispatch({
    type: FACEBOOK_BOT_ACTION_TYPES.GO_TO_MESSENGER_BOT,
    state: {
      displayMessage: currentTarget.innerText.trim(),
    },
  });
}

export const facebookBotActions = {
  goToMessengerBot,
};


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/facebook_bot/facebookBotActions.js